import React, { forwardRef } from 'react';
import styled from 'styled-components';

type OwnProps = React.SVGProps<SVGSVGElement>;

const DeliverySmall = styled.svg`
  fill: none;
  width: 32px;
  height: 32px;
`;

const DeliverySmallIcon = forwardRef<SVGSVGElement, OwnProps>((props, ref) => (
  <DeliverySmall
    {...props}
    ref={ref}
    viewBox="0 0 33 32"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M17.25 15H19.638C19.974 15 20.25 14.7073 20.25 14.3509V13.0655C20.25 12.6009 19.998 12.1745 19.608 11.9836L16.05 10.5455L13.6098 8.47498C13.2484 8.16833 12.7898 8 12.3158 8H8.98415C8.51018 8 8.05161 8.16833 7.6902 8.47497L5.63495 10.2188C5.38225 10.4332 5.08022 10.5815 4.75603 10.6502L3.83499 10.8456C2.91092 11.0416 2.25 11.8574 2.25 12.8021V14C2.25 14.5523 2.69772 15 3.25 15H5.24995H5.33535C5.54127 14.4174 6.09689 14 6.75 14C7.40311 14 7.95873 14.4174 8.16465 15H14.3354C14.5413 14.4174 15.0969 14 15.75 14C16.4031 14 16.9587 14.4174 17.1646 15H17.25Z"
      fill="#00AED9"
    />
    <path
      d="M24.25 11.9976H27.25C29.7611 12.0724 30.0478 13.3806 30.4277 15.4442L30.9106 18.7072C31.0894 19.9152 30.1533 21 28.9322 21H28.25M2.25 17L16.2842 20.9624C16.3726 20.9873 16.4641 21 16.5559 21H24.25V11H23.9708C23.5403 11 23.1582 11.2754 23.0221 11.6838L21.4779 16.3162C21.3418 16.7246 20.9597 17 20.5292 17H2.25Z"
      stroke="#00619E"
      strokeWidth="2"
      strokeLinejoin="round"
    />
    <circle cx="26.25" cy="21" r="2" stroke="#00619E" strokeWidth="2" />
    <circle cx="9.25" cy="21" r="2" stroke="#00619E" strokeWidth="2" />
  </DeliverySmall>
));

export default DeliverySmallIcon;
